import {
  CandidateExternalProcessStatusDto,
  CandidateMatchComponentTypeDto,
  CandidateRateSourceDto,
  CandidateSourceDto,
  CandidatesSortByDto,
  ExperienceCompanyTypeDto,
} from '@/api/generated';
import { candidateStatusesTranslation } from '@/assets/locales/views/candidates/details/candidateDetails.translation.pl.ts';
import {
  CandidateExternalProcessStatusTranslation,
  ProcessCandidatesListTranslation,
} from '@/assets/locales/views/processes/details/list/processCandidatesList.translation.en.ts';

export const candidateExternalProcessStatusTranslation: CandidateExternalProcessStatusTranslation =
  {
    [CandidateExternalProcessStatusDto.MarkedAsSent]: 'Ręcznie',
    [CandidateExternalProcessStatusDto.NotApplicable]: 'Nie dotyczy',
    [CandidateExternalProcessStatusDto.NotSent]: 'Nie',
    [CandidateExternalProcessStatusDto.Sent]: 'Tak',
  };

export const processCandidatesListTranslation: ProcessCandidatesListTranslation = {
  applicationSource: 'Źródło aplikacji',
  body: {
    actions: 'Akcje',
    applicationSources: 'Źródło aplikacji',
    candidateName: 'Imię i Nazwisko',
    [CandidatesSortByDto.Date]: 'Data',
    [CandidatesSortByDto.ExternalProcessStatus]: 'Status wysłania',
    [CandidatesSortByDto.Match]: 'Dopasowanie',
    [CandidatesSortByDto.OrdinalNumber]: 'ID',
    [CandidatesSortByDto.Rate]: 'Ocena',
    [CandidatesSortByDto.Source]: 'Źródło',
    [CandidatesSortByDto.Status]: 'Status',
    city: 'Miasto',
    componentMatch: {
      [CandidateMatchComponentTypeDto.CompanyLoyalty]: 'Lojalność',
      [CandidateMatchComponentTypeDto.IndustryExperience]: 'Preferowana branża',
      [CandidateMatchComponentTypeDto.MainAnalysis]: 'Główna analiza',
    },
    country: 'Kraj',
    expectedSalary: 'Oczekiwania finansowe',
    isInternalCandidate: 'Kandydat wewnętrzny',
    languages: 'Języki',
    ordinalNumber: 'ID',
    rateSource: 'Źródło oceny',
    tags: 'Tagi',
    voivodeship: 'Województwo',
  },
  dialog: {
    candidatesNotSentToExternalRecruitment:
      'Kandydaci z następującymi identyfikatorami: {{ids}} nie mogą zostać wysłani ze względu na swój status lub źródło. Prosimy o dokonanie analizy każdego kandydata z osobna.',
    confirmationAllSentToContent:
      "Czy na pewno chcesz przesunąć wszystkich kandydatów do statusu 'Wybrany przez AI'? Proszę potwierdzić, aby kontynuować.",
    confirmationMarkAsNotSentContent:
      'Czy na pewno chcesz oznaczyć tego kandydata jako NIE WYSŁANEGO? Upewnij się, że znajduje się w odpowiednim statusie w eRecruiterze',
    confirmationMarkAsSentContent:
      'Czy na pewno chcesz oznaczyć tego kandydata jako WYSŁANEGO? Upewnij się, że znajduje się w odpowiednim statusie w eRecruiterze',
    confirmationReprocessContent:
      'Czy na pewno chcesz przeprowadzić ponowną analizę tego kandydata? Proszę potwierdzić, aby kontynuować.',
    confirmationReprocessSelectedCandidates:
      'Czy na pewno chcesz przeprowadzić ponowną analizę wybranych kandydatów?',
    confirmationSentToERecruiter:
      "Czy na pewno chcesz przesunąć kandydata do statusu 'Wybrany przez AI'? Proszę potwierdzić, aby kontynuować.",
    confirmationSentToERecruiterWarning:
      "Proszę pamiętać, że kandydaci w statusie 'Błąd' NIE zostaną wysłani do eRecruitera",
    infoContent:
      'Kandydaci z następującymi identyfikatorami: {{ids}} nie mogą być ponownie wysłani do analizy ze względu na swój status. Prosimy o dokonanie analizy każdego kandydata z osobna.',
  },
  experienceCompanyTypes: {
    [ExperienceCompanyTypeDto.Competitor]: 'Konkurencja',
    [ExperienceCompanyTypeDto.None]: 'Żaden',
    [ExperienceCompanyTypeDto.Orange]: 'Orange',
    [ExperienceCompanyTypeDto.Partner]: 'Partner',
  },
  externalProcessStatuses: candidateExternalProcessStatusTranslation,
  head: {
    applicationSources: 'Źródło aplikacji',
    expectedSalary: 'Pensja do',
    experienceCompanyTypes: 'Typ firmy doświadczenia',
    externalProcessStatus: 'Status wysłania',
    isInternalCandidate: 'Kandydat wewnętrzny',
    location: 'Location',
    ordinalNumber: 'ID',
    rate: 'Ocena',
    searchPhrase: 'Szukaj po imieniu, nazwisku',
    statuses: 'Status',
    voivodeships: 'Województwa',
  },
  id: 'Id',
  labels: {
    discovery: 'Odkryj',
    eRecruiter: 'eRecruiter',
    refreshAnalysis: 'Ponów Analizę',
    sendTo: 'Wyślij do',
    uploadCV: 'Załącz CV (PDF lub ZIP)',
  },
  rateSources: {
    [CandidateRateSourceDto.Ai]: 'AI',
    [CandidateRateSourceDto.Recruiter]: 'Rekruter',
  },
  sources: {
    [CandidateSourceDto.Erecruiter]: 'eRecruiter',
    [CandidateSourceDto.KnowMe]: 'KnowMe',
  },
  statuses: candidateStatusesTranslation,
  statusInfo: {
    error: 'Błąd',
  },
  title: 'Kandydaci',
  tooltip: {
    discover: 'Szczegóły',
    markAsNotSent: 'Oznacz jako nie wysłany',
    markAsSent: 'Oznacz jako wysłany',
    matchComponents: 'Składowe oceny',
    refresh: 'Ponów Analizę',
  },
  tour: {
    experienceCompanyTypesFilter: {
      text: 'Kandydaci są przydzielani do jednej z grup doświadczenia: Orange, Partner, Konkurencja albo Żadne. Użyj tego filtru, aby wyświetlić kandydatów z wybraną grupą doświadczenia.',
      title: 'Filtr grup doświadczenia',
    },
    markAsSent: {
      text: 'Możesz zmienić status wysłania kandydata bez wysyłania danych do eRecruitera',
      title: 'Oznacz jako wysłany',
    },
    matchColumn: {
      text: 'Dla procesów B2C kandydaci mogą otrzymać dodatkowe punkty, m.in. za stabilność, lojalność, rzadkie zmienianie pracodawcy i pracę w preferowanych branżach. Gdy w kolumnie Dopasowanie pojawi się ikonka informacji, najedź na nią, aby zobaczyć składowe oceny.',
      title: 'Szczegóły dopasowania',
    },
    tagsColumn: {
      text: 'Tutaj widzisz tagi doświadczenia. Pokazują, czy kandydat ma doświadczenie w grupie Orange, Partner, Konkurencja albo Żadne.',
      title: 'Tagi doświadczenia',
    },
  },
};
